import { render, staticRenderFns } from "./multiSource.vue?vue&type=template&id=1f4e1880&scoped=true&"
import script from "./multiSource.vue?vue&type=script&lang=js&"
export * from "./multiSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e1880",
  null
  
)

export default component.exports